function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCienciaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "484px",
    height: "484px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M -0.5,-0.5 C 160.833,-0.5 322.167,-0.5 483.5,-0.5C 483.5,160.833 483.5,322.167 483.5,483.5C 322.167,483.5 160.833,483.5 -0.5,483.5C -0.5,322.167 -0.5,160.833 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#216e9d",
    d: "M 230.5,49.5 C 297.597,48.609 344.763,78.609 372,139.5C 388.373,188.533 381.373,233.866 351,275.5C 312.097,320.023 263.597,336.19 205.5,324C 156.498,308.998 123.998,277.164 108,228.5C 93.1361,168.764 108.969,118.93 155.5,79C 177.729,61.982 202.729,52.1486 230.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0eaf0",
    d: "M 229.5,57.5 C 284.675,55.8314 326.841,78.1647 356,124.5C 377.625,166.641 377.959,208.974 357,251.5C 328.249,299.301 285.749,322.134 229.5,320C 169.958,311.117 131.458,277.95 114,220.5C 103.299,167.938 117.799,123.771 157.5,88C 178.697,71.1044 202.697,60.9377 229.5,57.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d6d9c",
    d: "M 227.5,59.5 C 283.388,57.0212 325.888,79.3545 355,126.5C 371.787,158.768 375.121,192.435 365,227.5C 345.988,280.5 308.488,310.667 252.5,318C 198.841,320.09 157.675,298.59 129,253.5C 107.022,210.484 107.022,167.484 129,124.5C 151.888,87.782 184.721,66.1153 227.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8eff4",
    d: "M 324.5,110.5 C 326.665,110.116 328.332,110.783 329.5,112.5C 327.197,118.445 324.53,124.112 321.5,129.5C 320.5,129.167 319.833,128.5 319.5,127.5C 320.428,126.232 320.595,124.899 320,123.5C 318,121.5 316,119.5 314,117.5C 312.12,118.93 310.62,118.596 309.5,116.5C 309.709,115.914 310.043,115.414 310.5,115C 315.38,113.788 320.047,112.288 324.5,110.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#164f69",
    d: "M 229.5,103.5 C 271.433,100.869 301.6,118.203 320,155.5C 332.932,193.032 325.099,225.532 296.5,253C 269.297,273.61 239.631,277.944 207.5,266C 171.717,247.952 154.884,218.785 157,178.5C 164.472,137.197 188.638,112.197 229.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 306.5,234.5 C 298.311,226.145 290.311,217.645 282.5,209C 274.36,206.913 267.027,203.413 260.5,198.5C 266.801,199.686 271.634,197.686 275,192.5C 274.627,188.127 274.627,183.793 275,179.5C 272.303,177.424 269.47,175.757 266.5,174.5C 269.165,171.665 271.665,168.665 274,165.5C 275.913,161.471 275.913,157.471 274,153.5C 272.581,152.54 271.081,151.707 269.5,151C 263.449,150.254 257.449,150.421 251.5,151.5C 247.107,134.533 238.274,131.533 225,142.5C 224.828,145.826 224.995,149.159 225.5,152.5C 220.519,151.668 215.519,151.502 210.5,152C 204.493,153.672 202.327,157.505 204,163.5C 206.33,167.322 208.83,170.988 211.5,174.5C 207.097,178.799 204.097,183.966 202.5,190C 202.703,192.406 203.703,194.406 205.5,196C 209.768,196.801 213.435,198.634 216.5,201.5C 219.618,208.235 223.618,214.401 228.5,220C 232.419,221.862 236.419,223.529 240.5,225C 248.503,234.761 258.836,238.427 271.5,236C 278.884,239.891 285.551,244.724 291.5,250.5C 279.187,260.892 264.854,266.725 248.5,268C 210.193,269.669 183.027,253.169 167,218.5C 153.233,176.13 164.733,142.63 201.5,118C 237.659,100.567 270.492,105.4 300,132.5C 322.128,157.921 327.461,186.588 316,218.5C 313.563,224.392 310.396,229.726 306.5,234.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eef4f7",
    d: "M 165.5,99.5 C 173.021,99.5742 173.354,100.741 166.5,103C 162.47,106.957 162.803,110.623 167.5,114C 172.307,114.878 175.307,112.878 176.5,108C 179.091,107.699 179.925,108.866 179,111.5C 174.737,118.157 169.403,119.157 163,114.5C 159.088,108.64 159.921,103.64 165.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e7eff4",
    d: "M 304.5,94.5 C 311.58,93.6823 315.58,96.6823 316.5,103.5C 315.5,103.5 314.5,103.5 313.5,103.5C 313.703,101.61 313.037,100.11 311.5,99C 304.718,97.1248 301.552,99.6248 302,106.5C 304.663,108.579 307.496,110.245 310.5,111.5C 305.61,114.252 301.777,112.919 299,107.5C 298.333,105.167 298.333,102.833 299,100.5C 300.699,98.3039 302.533,96.3039 304.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9f0f5",
    d: "M 175.5,92.5 C 180.08,96.2618 183.747,100.928 186.5,106.5C 185.167,107.833 183.833,107.833 182.5,106.5C 180,102.833 177.5,99.1667 175,95.5C 174.53,94.4232 174.697,93.4232 175.5,92.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edf3f7",
    d: "M 290.5,83.5 C 291.586,83.62 292.253,84.2867 292.5,85.5C 291.11,89.2806 289.443,92.9472 287.5,96.5C 289.177,98.7605 291.343,100.427 294,101.5C 294.432,102.6 293.932,103.267 292.5,103.5C 288.78,102.649 285.78,100.816 283.5,98C 285.711,93.0793 288.044,88.2459 290.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1f6f9",
    d: "M 188.5,84.5 C 189.552,84.3505 190.552,84.5172 191.5,85C 194.99,87.9113 198.656,90.578 202.5,93C 204.037,94.1096 204.703,95.6096 204.5,97.5C 202.61,97.7035 201.11,97.0368 200,95.5C 197.579,96.9606 195.079,98.2939 192.5,99.5C 191.935,101.51 190.935,103.176 189.5,104.5C 188.503,97.8665 188.17,91.1998 188.5,84.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#28719e",
    d: "M 191.5,89.5 C 193.138,90.657 194.804,91.8236 196.5,93C 192.403,96.5332 190.737,95.3666 191.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebf2f6",
    d: "M 275.5,77.5 C 277.776,77.7565 278.943,79.0898 279,81.5C 280.434,86.821 280.601,92.1543 279.5,97.5C 278.148,96.4825 277.148,95.1492 276.5,93.5C 273.833,92.5 271.167,91.5 268.5,90.5C 267.15,91.9501 265.484,92.6168 263.5,92.5C 263.351,91.448 263.517,90.448 264,89.5C 268.037,85.631 271.87,81.631 275.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3978a4",
    d: "M 274.5,83.5 C 275.693,83.9704 276.36,84.9704 276.5,86.5C 276.167,87.5 275.833,88.5 275.5,89.5C 274.069,89.0234 272.736,88.3567 271.5,87.5C 272.524,86.1482 273.524,84.8149 274.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ecf2f6",
    d: "M 218.5,74.5 C 220.903,74.393 222.736,75.393 224,77.5C 226,80.1667 228,82.8333 230,85.5C 231.009,87.0249 231.509,88.6916 231.5,90.5C 229.257,89.6877 226.924,89.0211 224.5,88.5C 222.142,88.7529 219.808,89.0862 217.5,89.5C 217.426,93.5412 216.093,94.2079 213.5,91.5C 215.374,85.8803 217.04,80.2137 218.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3175a1",
    d: "M 220.5,79.5 C 222.054,80.9142 223.388,82.5808 224.5,84.5C 222.955,85.4519 221.288,85.7852 219.5,85.5C 219.517,83.4352 219.85,81.4352 220.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebf1f6",
    d: "M 240.5,71.5 C 251.632,72.0984 255.132,77.4317 251,87.5C 247.662,90.3181 243.829,91.1515 239.5,90C 237.333,89.1667 235.833,87.6667 235,85.5C 233.025,79.1772 234.858,74.5105 240.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#236f9d",
    d: "M 240.5,75.5 C 249.818,75.6546 251.818,79.488 246.5,87C 237.096,87.141 235.096,83.3076 240.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f6f9",
    d: "M 151.5,113.5 C 153.308,113.491 154.975,113.991 156.5,115C 160.005,117.675 163.339,120.509 166.5,123.5C 166.291,124.086 165.957,124.586 165.5,125C 160.5,125.333 155.5,125.667 150.5,126C 153,127.833 155.5,129.667 158,131.5C 158.483,132.448 158.649,133.448 158.5,134.5C 153.385,132.574 148.885,129.574 145,125.5C 144.517,124.552 144.351,123.552 144.5,122.5C 149.511,122.666 154.511,122.499 159.5,122C 157,120.167 154.5,118.333 152,116.5C 151.517,115.552 151.351,114.552 151.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#266e9c",
    d: "M 322.5,114.5 C 323.376,114.369 324.043,114.702 324.5,115.5C 323.667,117.167 322.833,118.833 322,120.5C 320.833,119.333 319.667,118.167 318.5,117C 320.066,116.392 321.4,115.558 322.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eef3f7",
    d: "M 336.5,123.5 C 337.995,123.415 338.995,124.081 339.5,125.5C 337.274,129.823 335.941,134.157 335.5,138.5C 338.619,136.274 341.952,134.607 345.5,133.5C 345.548,136.292 344.215,138.125 341.5,139C 338.294,141.034 334.96,142.867 331.5,144.5C 330.914,144.291 330.414,143.957 330,143.5C 330.674,138.81 332.174,134.31 334.5,130C 331.368,130.899 328.368,132.399 325.5,134.5C 324.5,134.167 323.833,133.5 323.5,132.5C 327.688,129.243 332.021,126.243 336.5,123.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ecf2f6",
    d: "M 134.5,131.5 C 135.675,131.281 136.675,131.614 137.5,132.5C 135.684,134.118 134.351,136.118 133.5,138.5C 132.167,135.862 132.5,133.529 134.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ecf2f6",
    d: "M 139.5,131.5 C 140.5,131.5 141.5,131.5 142.5,131.5C 141.8,134.063 140.8,136.563 139.5,139C 139.763,140.946 140.763,141.612 142.5,141C 143.5,139.333 144.5,137.667 145.5,136C 146.448,135.517 147.448,135.351 148.5,135.5C 148.076,138.354 147.076,141.021 145.5,143.5C 146.167,143.833 146.833,144.167 147.5,144.5C 149.749,142.863 151.415,140.696 152.5,138C 153.448,137.517 154.448,137.351 155.5,137.5C 154.554,142.059 152.554,146.059 149.5,149.5C 144.175,147.173 139.175,144.34 134.5,141C 136.307,137.885 137.973,134.719 139.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfaf8",
    d: "M 249.5,152.5 C 245.376,153.399 241.709,155.066 238.5,157.5C 234.975,155.77 231.309,154.436 227.5,153.5C 229.341,151.246 231.508,149.246 234,147.5C 234.374,145.102 234.374,142.769 234,140.5C 238.834,137.559 242.834,138.559 246,143.5C 247.741,146.309 248.908,149.309 249.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d44620",
    d: "M 251.5,151.5 C 251.158,152.338 250.492,152.672 249.5,152.5C 248.908,149.309 247.741,146.309 246,143.5C 242.834,138.559 238.834,137.559 234,140.5C 234.374,142.769 234.374,145.102 234,147.5C 231.508,149.246 229.341,151.246 227.5,153.5C 226.508,153.672 225.842,153.338 225.5,152.5C 224.995,149.159 224.828,145.826 225,142.5C 238.274,131.533 247.107,134.533 251.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eeb09d",
    d: "M 226.5,142.5 C 228.5,142.5 230.5,142.5 232.5,142.5C 233.508,147.667 231.675,149.334 227,147.5C 226.506,145.866 226.34,144.199 226.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1f5f8",
    d: "M 340.5,144.5 C 350.05,143.717 354.05,148.05 352.5,157.5C 351.5,157.5 350.5,157.5 349.5,157.5C 350.283,148.76 346.783,146.093 339,149.5C 338.219,150.729 337.719,152.062 337.5,153.5C 338.507,156.457 339.841,159.124 341.5,161.5C 336.583,160.721 334.25,157.721 334.5,152.5C 335.357,148.977 337.357,146.31 340.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebf2f6",
    d: "M 131.5,148.5 C 137.237,149.968 142.903,151.635 148.5,153.5C 148.5,154.5 148.5,155.5 148.5,156.5C 142.951,155.651 137.617,153.984 132.5,151.5C 131.614,150.675 131.281,149.675 131.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#48bd1e",
    d: "M 266.5,174.5 C 265.5,174.167 264.833,173.5 264.5,172.5C 269.141,168.551 271.641,163.551 272,157.5C 271.167,156.667 270.333,155.833 269.5,155C 263.984,154.183 258.65,154.349 253.5,155.5C 252.833,155.5 252.167,155.5 251.5,155.5C 248.421,156.304 245.421,157.304 242.5,158.5C 241.041,158.567 239.708,158.234 238.5,157.5C 241.709,155.066 245.376,153.399 249.5,152.5C 250.492,152.672 251.158,152.338 251.5,151.5C 257.449,150.421 263.449,150.254 269.5,151C 271.081,151.707 272.581,152.54 274,153.5C 275.913,157.471 275.913,161.471 274,165.5C 271.665,168.665 269.165,171.665 266.5,174.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfdfb",
    d: "M 264.5,172.5 C 261.167,170.167 257.833,167.833 254.5,165.5C 254.167,162.167 253.833,158.833 253.5,155.5C 258.65,154.349 263.984,154.183 269.5,155C 270.333,155.833 271.167,156.667 272,157.5C 271.641,163.551 269.141,168.551 264.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f9f2",
    d: "M 251.5,155.5 C 252.299,158.43 252.632,161.43 252.5,164.5C 249.131,162.485 245.798,160.485 242.5,158.5C 245.421,157.304 248.421,156.304 251.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebf1f6",
    d: "M 129.5,157.5 C 130.5,157.5 131.5,157.5 132.5,157.5C 131.748,160.09 130.748,162.59 129.5,165C 131.638,171.958 135.472,173.125 141,168.5C 141.422,165.764 141.422,163.098 141,160.5C 142,159.167 143,159.167 144,160.5C 146.106,172.066 141.606,176.233 130.5,173C 125.587,168.114 125.254,162.947 129.5,157.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f9f6",
    d: "M 238.5,160.5 C 247.37,163.761 255.037,168.761 261.5,175.5C 259.36,178.061 257.027,180.395 254.5,182.5C 258.025,181.241 261.025,179.241 263.5,176.5C 264.117,176.611 264.617,176.944 265,177.5C 265.333,179.833 265.667,182.167 266,184.5C 268.116,185.69 270.116,187.023 272,188.5C 272.536,190.567 272.036,192.401 270.5,194C 258.769,196.905 247.602,195.405 237,189.5C 236.5,189.667 236,189.833 235.5,190C 236.416,190.278 237.082,190.778 237.5,191.5C 234.167,192.5 230.833,193.5 227.5,194.5C 225.897,185.585 225.23,176.585 225.5,167.5C 229.347,164.407 233.68,162.074 238.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e78b6d",
    d: "M 251.5,155.5 C 252.167,155.5 252.833,155.5 253.5,155.5C 253.833,158.833 254.167,162.167 254.5,165.5C 253.833,165.167 253.167,164.833 252.5,164.5C 252.632,161.43 252.299,158.43 251.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edf3f7",
    d: "M 349.5,163.5 C 351.833,163.5 354.167,163.5 356.5,163.5C 357.021,167.481 357.354,171.481 357.5,175.5C 356.5,175.5 355.5,175.5 354.5,175.5C 354.662,173.473 354.495,171.473 354,169.5C 352.847,167.503 351.347,167.17 349.5,168.5C 350.374,170.747 350.708,173.08 350.5,175.5C 349.178,175.67 348.011,175.337 347,174.5C 346.505,172.527 346.338,170.527 346.5,168.5C 345.167,168.5 343.833,168.5 342.5,168.5C 343.051,171.807 343.384,175.14 343.5,178.5C 342.5,178.5 341.5,178.5 340.5,178.5C 339.755,174.46 339.255,170.46 339,166.5C 342.61,165.552 346.11,164.552 349.5,163.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4bd5fa",
    d: "M 225.5,152.5 C 225.842,153.338 226.508,153.672 227.5,153.5C 231.309,154.436 234.975,155.77 238.5,157.5C 239.708,158.234 241.041,158.567 242.5,158.5C 245.798,160.485 249.131,162.485 252.5,164.5C 253.167,164.833 253.833,165.167 254.5,165.5C 257.833,167.833 261.167,170.167 264.5,172.5C 264.833,173.5 265.5,174.167 266.5,174.5C 269.47,175.757 272.303,177.424 275,179.5C 274.627,183.793 274.627,188.127 275,192.5C 271.634,197.686 266.801,199.686 260.5,198.5C 257.833,198.167 255.167,197.833 252.5,197.5C 252.5,196.833 252.167,196.5 251.5,196.5C 247.051,195.108 242.718,193.441 238.5,191.5C 238.167,191.5 237.833,191.5 237.5,191.5C 237.082,190.778 236.416,190.278 235.5,190C 236,189.833 236.5,189.667 237,189.5C 247.602,195.405 258.769,196.905 270.5,194C 272.036,192.401 272.536,190.567 272,188.5C 270.116,187.023 268.116,185.69 266,184.5C 265.667,182.167 265.333,179.833 265,177.5C 264.617,176.944 264.117,176.611 263.5,176.5C 263.158,175.662 262.492,175.328 261.5,175.5C 255.037,168.761 247.37,163.761 238.5,160.5C 237.22,159.069 235.553,158.402 233.5,158.5C 231.321,157.323 228.987,156.323 226.5,155.5C 225.833,155.5 225.167,155.5 224.5,155.5C 219.759,153.692 214.759,153.192 209.5,154C 205.708,156.053 204.542,159.219 206,163.5C 207.791,167.439 210.291,170.772 213.5,173.5C 213.5,173.833 213.5,174.167 213.5,174.5C 212.833,174.5 212.167,174.5 211.5,174.5C 208.83,170.988 206.33,167.322 204,163.5C 202.327,157.505 204.493,153.672 210.5,152C 215.519,151.502 220.519,151.668 225.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4abd1f",
    d: "M 233.5,158.5 C 235.553,158.402 237.22,159.069 238.5,160.5C 233.68,162.074 229.347,164.407 225.5,167.5C 224.29,167.932 223.29,168.599 222.5,169.5C 220.095,170.398 218.095,171.898 216.5,174C 215.552,174.483 214.552,174.649 213.5,174.5C 213.5,174.167 213.5,173.833 213.5,173.5C 216.833,170.5 220.167,167.5 223.5,164.5C 224.492,164.672 225.158,164.338 225.5,163.5C 228.54,162.32 231.206,160.653 233.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cf3a0c",
    d: "M 224.5,155.5 C 225.167,155.5 225.833,155.5 226.5,155.5C 226.167,158.167 225.833,160.833 225.5,163.5C 225.158,164.338 224.492,164.672 223.5,164.5C 223.368,161.43 223.701,158.43 224.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7ece2",
    d: "M 226.5,155.5 C 228.987,156.323 231.321,157.323 233.5,158.5C 231.206,160.653 228.54,162.32 225.5,163.5C 225.833,160.833 226.167,158.167 226.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfcfb",
    d: "M 224.5,155.5 C 223.701,158.43 223.368,161.43 223.5,164.5C 220.167,167.5 216.833,170.5 213.5,173.5C 210.291,170.772 207.791,167.439 206,163.5C 204.542,159.219 205.708,156.053 209.5,154C 214.759,153.192 219.759,153.692 224.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c3c3b",
    d: "M 235.5,167.5 C 244.055,165.82 248.221,169.153 248,177.5C 243.47,184.588 238.137,185.255 232,179.5C 229.458,174.361 230.624,170.361 235.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7fcf9",
    d: "M 222.5,169.5 C 222.341,176.59 223.007,183.59 224.5,190.5C 223.9,191.9 222.9,192.9 221.5,193.5C 217.154,191.584 213.654,192.584 211,196.5C 205.862,195.024 204.195,191.69 206,186.5C 208.751,182.598 211.251,178.598 213.5,174.5C 214.552,174.649 215.552,174.483 216.5,174C 218.095,171.898 220.095,170.398 222.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d8512e",
    d: "M 225.5,167.5 C 225.23,176.585 225.897,185.585 227.5,194.5C 226.022,193.552 225.022,192.219 224.5,190.5C 223.007,183.59 222.341,176.59 222.5,169.5C 223.29,168.599 224.29,167.932 225.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5bc435",
    d: "M 261.5,175.5 C 262.492,175.328 263.158,175.662 263.5,176.5C 261.025,179.241 258.025,181.241 254.5,182.5C 257.027,180.395 259.36,178.061 261.5,175.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#737372",
    d: "M 235.5,177.5 C 232.959,175.56 232.959,173.393 235.5,171C 242.328,169.176 245.494,171.676 245,178.5C 242.503,180.478 239.669,180.978 236.5,180C 235.748,179.329 235.414,178.496 235.5,177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#adadad",
    d: "M 235.5,177.5 C 235.314,171.296 237.814,169.963 243,173.5C 243.495,179.798 240.995,181.132 235.5,177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8dd76a",
    d: "M 254.5,182.5 C 253.998,184.085 252.998,184.585 251.5,184C 252.244,182.961 253.244,182.461 254.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#63c436",
    d: "M 211.5,174.5 C 212.167,174.5 212.833,174.5 213.5,174.5C 211.251,178.598 208.751,182.598 206,186.5C 204.195,191.69 205.862,195.024 211,196.5C 213.654,192.584 217.154,191.584 221.5,193.5C 222.802,195.028 224.469,196.028 226.5,196.5C 225.448,196.351 224.448,196.517 223.5,197C 222.323,200.349 219.99,201.849 216.5,201.5C 213.435,198.634 209.768,196.801 205.5,196C 203.703,194.406 202.703,192.406 202.5,190C 204.097,183.966 207.097,178.799 211.5,174.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faf8f6",
    d: "M 238.5,191.5 C 242.718,193.441 247.051,195.108 251.5,196.5C 251.598,198.553 250.931,200.22 249.5,201.5C 249.306,199.088 247.973,198.088 245.5,198.5C 243.887,202.677 242.887,207.011 242.5,211.5C 241.5,211.5 240.5,211.5 239.5,211.5C 238.823,206.199 238.323,200.866 238,195.5C 237.283,194.956 236.783,194.289 236.5,193.5C 237.167,192.833 237.833,192.167 238.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b48148",
    d: "M 224.5,190.5 C 225.022,192.219 226.022,193.552 227.5,194.5C 227.5,195.167 227.833,195.5 228.5,195.5C 228.5,195.833 228.5,196.167 228.5,196.5C 227.833,196.5 227.167,196.5 226.5,196.5C 224.469,196.028 222.802,195.028 221.5,193.5C 222.9,192.9 223.9,191.9 224.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b0e195",
    d: "M 237.5,191.5 C 237.833,191.5 238.167,191.5 238.5,191.5C 237.833,192.167 237.167,192.833 236.5,193.5C 235.041,193.433 233.708,193.766 232.5,194.5C 231.292,195.234 229.959,195.567 228.5,195.5C 227.833,195.5 227.5,195.167 227.5,194.5C 230.833,193.5 234.167,192.5 237.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf8f6",
    d: "M 232.5,194.5 C 232.813,198.042 232.479,201.375 231.5,204.5C 230.108,201.993 229.108,199.327 228.5,196.5C 228.5,196.167 228.5,195.833 228.5,195.5C 229.959,195.567 231.292,195.234 232.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9763f",
    d: "M 236.5,193.5 C 236.783,194.289 237.283,194.956 238,195.5C 238.323,200.866 238.823,206.199 239.5,211.5C 235.593,210.593 232.926,208.26 231.5,204.5C 232.479,201.375 232.813,198.042 232.5,194.5C 233.708,193.766 235.041,193.433 236.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5e59c",
    d: "M 214.5,194.5 C 216.167,194.5 217.833,194.5 219.5,194.5C 219.5,196.167 219.5,197.833 219.5,199.5C 217.833,199.5 216.167,199.5 214.5,199.5C 214.5,197.833 214.5,196.167 214.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f9fb",
    d: "M 132.5,202.5 C 139.669,201.513 143.169,204.513 143,211.5C 139.468,217.29 135.135,217.957 130,213.5C 127.826,209.193 128.659,205.526 132.5,202.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f9fb",
    d: "M 343.5,202.5 C 349.523,201.197 353.189,203.53 354.5,209.5C 353.006,215.25 349.339,217.416 343.5,216C 338.221,211.503 338.221,207.003 343.5,202.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ad7a43",
    d: "M 226.5,196.5 C 227.822,202.644 230.822,207.811 235.5,212C 237.695,213.373 240.029,213.706 242.5,213C 244.66,211.668 246.66,210.168 248.5,208.5C 248.5,210.167 248.5,211.833 248.5,213.5C 252.828,213.963 256.828,213.13 260.5,211C 255.637,209.94 252.637,207.106 251.5,202.5C 252.038,200.883 252.371,199.216 252.5,197.5C 255.167,197.833 257.833,198.167 260.5,198.5C 267.027,203.413 274.36,206.913 282.5,209C 290.311,217.645 298.311,226.145 306.5,234.5C 302.882,241.118 297.882,246.452 291.5,250.5C 285.551,244.724 278.884,239.891 271.5,236C 258.836,238.427 248.503,234.761 240.5,225C 236.419,223.529 232.419,221.862 228.5,220C 223.618,214.401 219.618,208.235 216.5,201.5C 219.99,201.849 222.323,200.349 223.5,197C 224.448,196.517 225.448,196.351 226.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f6f3",
    d: "M 251.5,202.5 C 252.637,207.106 255.637,209.94 260.5,211C 256.828,213.13 252.828,213.963 248.5,213.5C 248.5,211.833 248.5,210.167 248.5,208.5C 248.992,206.181 249.992,204.181 251.5,202.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ce4317",
    d: "M 226.5,196.5 C 227.167,196.5 227.833,196.5 228.5,196.5C 229.108,199.327 230.108,201.993 231.5,204.5C 232.926,208.26 235.593,210.593 239.5,211.5C 240.5,211.5 241.5,211.5 242.5,211.5C 246.307,209.225 248.641,205.892 249.5,201.5C 250.931,200.22 251.598,198.553 251.5,196.5C 252.167,196.5 252.5,196.833 252.5,197.5C 252.371,199.216 252.038,200.883 251.5,202.5C 249.992,204.181 248.992,206.181 248.5,208.5C 246.66,210.168 244.66,211.668 242.5,213C 240.029,213.706 237.695,213.373 235.5,212C 230.822,207.811 227.822,202.644 226.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ab773f",
    d: "M 249.5,201.5 C 248.641,205.892 246.307,209.225 242.5,211.5C 242.887,207.011 243.887,202.677 245.5,198.5C 247.973,198.088 249.306,199.088 249.5,201.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebf1f6",
    d: "M 332.5,239.5 C 333.978,239.238 335.311,239.571 336.5,240.5C 335.135,241.941 333.635,243.274 332,244.5C 331.517,245.448 331.351,246.448 331.5,247.5C 335.112,246.947 338.612,245.947 342,244.5C 344.833,244.667 346.333,246.167 346.5,249C 345.401,255.16 342.067,257.494 336.5,256C 339.72,254.734 342.053,252.567 343.5,249.5C 343.113,248.28 342.28,247.613 341,247.5C 337.879,249.986 334.379,251.153 330.5,251C 328.556,248.847 328.056,246.347 329,243.5C 330.376,242.295 331.542,240.962 332.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebf1f6",
    d: "M 151.5,244.5 C 160.081,246.929 162.581,252.262 159,260.5C 151.603,265.437 145.77,263.937 141.5,256C 144.656,252.011 147.989,248.177 151.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#226f9d",
    d: "M 152.5,248.5 C 155.704,249.378 157.37,251.545 157.5,255C 154.228,261.805 150.228,262.139 145.5,256C 148.039,253.63 150.372,251.13 152.5,248.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9f0f5",
    d: "M 310.5,259.5 C 322.431,260.246 325.431,265.746 319.5,276C 312.838,280.27 308.005,278.77 305,271.5C 303.873,266.089 305.707,262.089 310.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#206d9c",
    d: "M 310.5,263.5 C 315.706,262.12 318.706,263.953 319.5,269C 317.58,274.741 314.08,275.908 309,272.5C 306.788,269.021 307.288,266.021 310.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1f6f9",
    d: "M 180.5,266.5 C 182.456,272.412 183.123,278.745 182.5,285.5C 181.5,285.5 180.5,285.5 179.5,285.5C 179.714,283.856 179.38,282.356 178.5,281C 174.858,277.988 170.858,277.155 166.5,278.5C 166.281,277.325 166.614,276.325 167.5,275.5C 172.074,272.724 176.407,269.724 180.5,266.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfeaf0",
    d: "M 282.5,270.5 C 284.028,270.517 284.528,271.184 284,272.5C 282.115,274.02 279.949,275.02 277.5,275.5C 276.417,274.635 276.251,273.635 277,272.5C 278.948,271.891 280.782,271.224 282.5,270.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d729f",
    d: "M 178.5,271.5 C 179.793,273.364 179.793,275.364 178.5,277.5C 177.3,276.469 175.966,275.635 174.5,275C 175.731,273.595 177.064,272.429 178.5,271.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eaf1f5",
    d: "M 280.5,275.5 C 281.552,275.351 282.552,275.517 283.5,276C 287,279.5 290.5,283 294,286.5C 294.483,287.448 294.649,288.448 294.5,289.5C 290.77,288.011 287.103,288.178 283.5,290C 281.893,291.049 281.227,292.549 281.5,294.5C 280.5,294.5 279.5,294.5 278.5,294.5C 278.445,288.046 279.112,281.712 280.5,275.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9f0f5",
    d: "M 202.5,276.5 C 206.741,275.75 210.074,277.083 212.5,280.5C 212.192,281.308 211.692,281.975 211,282.5C 209.005,280.253 206.505,279.253 203.5,279.5C 204.315,283.159 206.481,285.826 210,287.5C 211.756,292.406 210.089,295.073 205,295.5C 202.432,295.049 200.098,294.049 198,292.5C 197.219,291.056 197.386,289.723 198.5,288.5C 200.28,290.444 202.447,291.777 205,292.5C 206.5,292.333 207.333,291.5 207.5,290C 205.644,287.819 203.477,285.985 201,284.5C 200.109,281.502 200.609,278.836 202.5,276.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eff4f8",
    d: "M 256.5,281.5 C 257.5,281.5 258.5,281.5 259.5,281.5C 260.22,287.138 260.553,292.804 260.5,298.5C 259.5,298.5 258.5,298.5 257.5,298.5C 257.82,295.102 257.487,291.768 256.5,288.5C 255.299,290.909 253.633,292.909 251.5,294.5C 249.851,293.352 248.351,292.019 247,290.5C 246.502,293.482 246.335,296.482 246.5,299.5C 245.5,299.5 244.5,299.5 243.5,299.5C 243.553,293.804 243.22,288.138 242.5,282.5C 243.552,282.351 244.552,282.517 245.5,283C 246.976,285.643 248.976,287.81 251.5,289.5C 253.678,287.142 255.345,284.475 256.5,281.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#266f9d",
    d: "M 282.5,280.5 C 284.296,281.793 285.963,283.293 287.5,285C 283.289,287.188 281.622,285.688 282.5,280.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#216a9a",
    d: "M 225.5,349.5 C 226.833,349.5 228.167,349.5 229.5,349.5C 229.5,350.833 229.5,352.167 229.5,353.5C 228.167,353.5 226.833,353.5 225.5,353.5C 225.5,352.167 225.5,350.833 225.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#266f9d",
    d: "M 150.5,349.5 C 151.833,349.5 153.167,349.5 154.5,349.5C 154.114,353.738 152.448,354.404 149.5,351.5C 149.863,350.817 150.196,350.15 150.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#27709d",
    d: "M 184.5,349.5 C 185.833,349.5 187.167,349.5 188.5,349.5C 188.114,353.738 186.448,354.404 183.5,351.5C 183.863,350.817 184.196,350.15 184.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#236d9c",
    d: "M 212.5,349.5 C 213.833,349.5 215.167,349.5 216.5,349.5C 216.114,353.738 214.448,354.404 211.5,351.5C 211.863,350.817 212.196,350.15 212.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256e9d",
    d: "M 107.5,349.5 C 108.833,349.5 110.167,349.5 111.5,349.5C 111.114,353.738 109.448,354.404 106.5,351.5C 106.863,350.817 107.196,350.15 107.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256e9c",
    d: "M 122.5,349.5 C 123.833,349.5 125.167,349.5 126.5,349.5C 126.114,353.738 124.448,354.404 121.5,351.5C 121.863,350.817 122.196,350.15 122.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256e9d",
    d: "M 142.5,349.5 C 143.873,349.343 145.207,349.51 146.5,350C 147.674,352.829 146.674,353.829 143.5,353C 142.663,351.989 142.33,350.822 142.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256e9c",
    d: "M 170.5,349.5 C 171.873,349.343 173.207,349.51 174.5,350C 175.674,352.829 174.674,353.829 171.5,353C 170.663,351.989 170.33,350.822 170.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#276f9d",
    d: "M 204.5,349.5 C 205.873,349.343 207.207,349.51 208.5,350C 209.674,352.829 208.674,353.829 205.5,353C 204.663,351.989 204.33,350.822 204.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d6a9a",
    d: "M 232.5,349.5 C 233.833,349.5 235.167,349.5 236.5,349.5C 236.5,350.833 236.5,352.167 236.5,353.5C 233.5,353.833 232.167,352.5 232.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1a6898",
    d: "M 253.5,349.5 C 254.833,349.5 256.167,349.5 257.5,349.5C 257.833,352.5 256.5,353.833 253.5,353.5C 253.5,352.167 253.5,350.833 253.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d6a9a",
    d: "M 266.5,349.5 C 267.833,349.5 269.167,349.5 270.5,349.5C 270.5,350.833 270.5,352.167 270.5,353.5C 267.5,353.833 266.167,352.5 266.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#206b9a",
    d: "M 163.5,356.5 C 164.833,356.5 166.167,356.5 167.5,356.5C 167.5,357.833 167.5,359.167 167.5,360.5C 166.167,360.5 164.833,360.5 163.5,360.5C 163.5,359.167 163.5,357.833 163.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256f9d",
    d: "M 184.5,356.5 C 187.5,356.167 188.833,357.5 188.5,360.5C 184.56,361.234 183.227,359.901 184.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#246c9b",
    d: "M 212.5,356.5 C 215.5,356.167 216.833,357.5 216.5,360.5C 212.56,361.234 211.227,359.901 212.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#246c9b",
    d: "M 246.5,356.5 C 249.5,356.167 250.833,357.5 250.5,360.5C 246.56,361.234 245.227,359.901 246.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d6b9b",
    d: "M 192.5,363.5 C 195.956,364.536 196.29,366.203 193.5,368.5C 191.296,367.218 190.962,365.551 192.5,363.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3375a2",
    d: "M 107.5,363.5 C 111.161,363.35 112.161,364.85 110.5,368C 106.707,368.487 105.707,366.987 107.5,363.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3175a1",
    d: "M 122.5,363.5 C 126.161,363.35 127.161,364.85 125.5,368C 121.707,368.487 120.707,366.987 122.5,363.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2a6f9d",
    d: "M 205.5,363.5 C 206.5,363.5 207.5,363.5 208.5,363.5C 208.5,365.167 208.5,366.833 208.5,368.5C 204.716,368.475 203.716,366.808 205.5,363.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256e9c",
    d: "M 210.5,381.5 C 214.161,381.35 215.161,382.85 213.5,386C 212.551,386.617 211.718,386.451 211,385.5C 210.51,384.207 210.343,382.873 210.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256e9c",
    d: "M 225.5,381.5 C 229.161,381.35 230.161,382.85 228.5,386C 227.551,386.617 226.718,386.451 226,385.5C 225.51,384.207 225.343,382.873 225.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#246e9c",
    d: "M 295.5,381.5 C 296.5,381.5 297.5,381.5 298.5,381.5C 298.884,383.665 298.217,385.332 296.5,386.5C 294.296,385.218 293.962,383.551 295.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256e9c",
    d: "M 329.5,381.5 C 330.5,381.5 331.5,381.5 332.5,381.5C 332.884,383.665 332.217,385.332 330.5,386.5C 328.296,385.218 327.962,383.551 329.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#246d9c",
    d: "M 357.5,381.5 C 358.5,381.5 359.5,381.5 360.5,381.5C 360.884,383.665 360.217,385.332 358.5,386.5C 356.296,385.218 355.962,383.551 357.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3074a0",
    d: "M 107.5,381.5 C 111.161,381.35 112.161,382.85 110.5,386C 107.041,386.145 106.041,384.645 107.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3877a3",
    d: "M 122.5,381.5 C 126.161,381.35 127.161,382.85 125.5,386C 121.707,386.487 120.707,384.987 122.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3777a3",
    d: "M 246.5,381.5 C 250.161,381.35 251.161,382.85 249.5,386C 245.707,386.487 244.707,384.987 246.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256e9d",
    d: "M 267.5,381.5 C 268.5,381.5 269.5,381.5 270.5,381.5C 270.884,383.665 270.217,385.332 268.5,386.5C 266.296,385.218 265.962,383.551 267.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#276f9d",
    d: "M 287.5,381.5 C 291.161,381.35 292.161,382.85 290.5,386C 289.551,386.617 288.718,386.451 288,385.5C 287.51,384.207 287.343,382.873 287.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#28709e",
    d: "M 349.5,381.5 C 353.161,381.35 354.161,382.85 352.5,386C 351.551,386.617 350.718,386.451 350,385.5C 349.51,384.207 349.343,382.873 349.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a78a4",
    d: "M 143.5,381.5 C 147.161,381.35 148.161,382.85 146.5,386C 142.707,386.487 141.707,384.987 143.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e719f",
    d: "M 163.5,381.5 C 164.833,381.5 166.167,381.5 167.5,381.5C 167.884,383.665 167.217,385.332 165.5,386.5C 163.783,385.332 163.116,383.665 163.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3575a2",
    d: "M 308.5,381.5 C 312.161,381.35 313.161,382.85 311.5,386C 307.707,386.487 306.707,384.987 308.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3776a2",
    d: "M 336.5,381.5 C 340.161,381.35 341.161,382.85 339.5,386C 335.707,386.487 334.707,384.987 336.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3777a2",
    d: "M 370.5,381.5 C 374.161,381.35 375.161,382.85 373.5,386C 369.707,386.487 368.707,384.987 370.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#266e9c",
    d: "M 267.5,388.5 C 270.084,389.048 271.084,390.715 270.5,393.5C 266.716,393.475 265.716,391.808 267.5,388.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3878a3",
    d: "M 336.5,388.5 C 340.161,388.35 341.161,389.85 339.5,393C 335.707,393.487 334.707,391.987 336.5,388.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a78a4",
    d: "M 377.5,388.5 C 381.161,388.35 382.161,389.85 380.5,393C 376.707,393.487 375.707,391.987 377.5,388.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3475a1",
    d: "M 171.5,388.5 C 174.685,388.722 175.685,390.222 174.5,393C 170.707,393.487 169.707,391.987 171.5,388.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#206b9a",
    d: "M 163.5,396.5 C 164.833,396.5 166.167,396.5 167.5,396.5C 167.5,397.833 167.5,399.167 167.5,400.5C 166.167,400.5 164.833,400.5 163.5,400.5C 163.5,399.167 163.5,397.833 163.5,396.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256e9c",
    d: "M 210.5,396.5 C 211.833,396.5 213.167,396.5 214.5,396.5C 214.5,397.833 214.5,399.167 214.5,400.5C 213.167,400.5 211.833,400.5 210.5,400.5C 210.5,399.167 210.5,397.833 210.5,396.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#216b9a",
    d: "M 328.5,396.5 C 329.833,396.5 331.167,396.5 332.5,396.5C 332.5,397.833 332.5,399.167 332.5,400.5C 331.167,400.5 329.833,400.5 328.5,400.5C 328.5,399.167 328.5,397.833 328.5,396.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256e9c",
    d: "M 107.5,396.5 C 108.833,396.5 110.167,396.5 111.5,396.5C 111.114,400.738 109.448,401.404 106.5,398.5C 106.863,397.817 107.196,397.15 107.5,396.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256e9c",
    d: "M 122.5,396.5 C 123.833,396.5 125.167,396.5 126.5,396.5C 126.114,400.738 124.448,401.404 121.5,398.5C 121.863,397.817 122.196,397.15 122.5,396.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3172a0",
    d: "M 266.5,396.5 C 268.665,396.116 270.332,396.783 271.5,398.5C 270.332,400.217 268.665,400.884 266.5,400.5C 266.5,399.167 266.5,397.833 266.5,396.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#236b9a",
    d: "M 225.5,396.5 C 226.833,396.5 228.167,396.5 229.5,396.5C 229.5,397.833 229.5,399.167 229.5,400.5C 228.167,400.5 226.833,400.5 225.5,400.5C 225.5,399.167 225.5,397.833 225.5,396.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#246c9b",
    d: "M 150.5,414.5 C 151.833,414.5 153.167,414.5 154.5,414.5C 154.114,418.738 152.448,419.404 149.5,416.5C 149.863,415.817 150.196,415.15 150.5,414.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#216b9b",
    d: "M 163.5,414.5 C 164.833,414.5 166.167,414.5 167.5,414.5C 167.5,415.833 167.5,417.167 167.5,418.5C 166.167,418.5 164.833,418.5 163.5,418.5C 163.5,417.167 163.5,415.833 163.5,414.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#236c9b",
    d: "M 191.5,414.5 C 192.833,414.5 194.167,414.5 195.5,414.5C 195.5,415.833 195.5,417.167 195.5,418.5C 194.167,418.5 192.833,418.5 191.5,418.5C 191.5,417.167 191.5,415.833 191.5,414.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#296f9d",
    d: "M 295.5,413.5 C 298.084,414.048 299.084,415.715 298.5,418.5C 297.167,418.5 295.833,418.5 294.5,418.5C 294.366,416.708 294.699,415.042 295.5,413.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#27709d",
    d: "M 335.5,414.5 C 336.873,414.343 338.207,414.51 339.5,415C 340.674,417.829 339.674,418.829 336.5,418C 335.663,416.989 335.33,415.822 335.5,414.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#246d9c",
    d: "M 122.5,414.5 C 123.833,414.5 125.167,414.5 126.5,414.5C 126.114,418.738 124.448,419.404 121.5,416.5C 121.863,415.817 122.196,415.15 122.5,414.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#266e9d",
    d: "M 142.5,414.5 C 143.873,414.343 145.207,414.51 146.5,415C 147.674,417.829 146.674,418.829 143.5,418C 142.663,416.989 142.33,415.822 142.5,414.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d6a99",
    d: "M 266.5,414.5 C 267.833,414.5 269.167,414.5 270.5,414.5C 270.5,415.833 270.5,417.167 270.5,418.5C 267.5,418.833 266.167,417.5 266.5,414.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#266e9c",
    d: "M 107.5,414.5 C 108.833,414.5 110.167,414.5 111.5,414.5C 111.114,418.738 109.448,419.404 106.5,416.5C 106.863,415.817 107.196,415.15 107.5,414.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#216c9b",
    d: "M 231.5,414.5 C 232.833,414.5 234.167,414.5 235.5,414.5C 235.114,418.738 233.448,419.404 230.5,416.5C 230.863,415.817 231.196,415.15 231.5,414.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#216c9b",
    d: "M 246.5,414.5 C 247.833,414.5 249.167,414.5 250.5,414.5C 250.114,418.738 248.448,419.404 245.5,416.5C 245.863,415.817 246.196,415.15 246.5,414.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#226c9b",
    d: "M 273.5,414.5 C 274.873,414.343 276.207,414.51 277.5,415C 278.674,417.829 277.674,418.829 274.5,418C 273.663,416.989 273.33,415.822 273.5,414.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#226c9b",
    d: "M 307.5,414.5 C 308.873,414.343 310.207,414.51 311.5,415C 312.674,417.829 311.674,418.829 308.5,418C 307.663,416.989 307.33,415.822 307.5,414.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#276e9c",
    d: "M 315.5,421.5 C 318.5,421.167 319.833,422.5 319.5,425.5C 315.56,426.234 314.227,424.901 315.5,421.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256e9d",
    d: "M 184.5,421.5 C 187.5,421.167 188.833,422.5 188.5,425.5C 184.56,426.234 183.227,424.901 184.5,421.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#246d9c",
    d: "M 150.5,421.5 C 153.5,421.167 154.833,422.5 154.5,425.5C 150.56,426.234 149.227,424.901 150.5,421.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256d9c",
    d: "M 294.5,421.5 C 295.833,421.5 297.167,421.5 298.5,421.5C 298.5,422.833 298.5,424.167 298.5,425.5C 297.167,425.5 295.833,425.5 294.5,425.5C 294.5,424.167 294.5,422.833 294.5,421.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#206b9b",
    d: "M 328.5,421.5 C 329.833,421.5 331.167,421.5 332.5,421.5C 332.5,422.833 332.5,424.167 332.5,425.5C 331.167,425.5 329.833,425.5 328.5,425.5C 328.5,424.167 328.5,422.833 328.5,421.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#266f9d",
    d: "M 287.5,428.5 C 291.161,428.35 292.161,429.85 290.5,433C 289.551,433.617 288.718,433.451 288,432.5C 287.51,431.207 287.343,429.873 287.5,428.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#256e9d",
    d: "M 329.5,428.5 C 330.5,428.5 331.5,428.5 332.5,428.5C 332.884,430.665 332.217,432.332 330.5,433.5C 328.296,432.218 327.962,430.551 329.5,428.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3174a0",
    d: "M 107.5,428.5 C 111.161,428.35 112.161,429.85 110.5,433C 106.707,433.487 105.707,431.987 107.5,428.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3676a2",
    d: "M 122.5,428.5 C 126.161,428.35 127.161,429.85 125.5,433C 121.707,433.487 120.707,431.987 122.5,428.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3576a2",
    d: "M 184.5,428.5 C 188.161,428.35 189.161,429.85 187.5,433C 183.707,433.487 182.707,431.987 184.5,428.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3477a2",
    d: "M 231.5,428.5 C 235.161,428.35 236.161,429.85 234.5,433C 230.707,433.487 229.707,431.987 231.5,428.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3476a2",
    d: "M 246.5,428.5 C 250.161,428.35 251.161,429.85 249.5,433C 245.707,433.487 244.707,431.987 246.5,428.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#216d9b",
    d: "M 267.5,428.5 C 268.5,428.5 269.5,428.5 270.5,428.5C 270.884,430.665 270.217,432.332 268.5,433.5C 266.296,432.218 265.962,430.551 267.5,428.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3576a2",
    d: "M 308.5,428.5 C 312.161,428.35 313.161,429.85 311.5,433C 307.707,433.487 306.707,431.987 308.5,428.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCienciaLogo);
export default __webpack_public_path__ + "static/media/cienciaLogo.27158b87c799787e885a546cfd147b3b.svg";
export { ForwardRef as ReactComponent };